import { Component, OnInit, OnDestroy, ElementRef, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { BannerService, BannerConfig } from '../../services/banner.service';

@Component({
  selector: 'app-banner-container',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './banner-container.component.html',
  styleUrls: ['./banner-container.component.scss']
})
export class BannerContainerComponent implements OnInit, OnDestroy {
  @ViewChild('banner', { static: false }) bannerElement?: ElementRef;
  
  currentBanner: BannerConfig | null = null;
  private destroy$ = new Subject<void>();

  constructor(private bannerService: BannerService) {}

  ngOnInit(): void {
    this.bannerService.banner$
      .pipe(takeUntil(this.destroy$))
      .subscribe(banner => {
        this.showBanner(banner);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async showBanner(banner: BannerConfig): Promise<void> {
    this.currentBanner = banner;

    if (banner.customColor) {
      // Custom colored banner — auto-dismiss by timer only
      if (banner.duration && banner.duration > 0) {
        setTimeout(() => {
          this.currentBanner = null;
        }, banner.duration);
      }
      return;
    }

    // Wait for the element to be available
    setTimeout(async () => {
      if (this.bannerElement?.nativeElement) {
        const bannerEl = this.bannerElement.nativeElement;
        await bannerEl.setOpen();
        
        // Auto dismiss if duration is set
        if (banner.duration && banner.duration > 0) {
          setTimeout(async () => {
            await bannerEl.setClose();
            this.currentBanner = null;
          }, banner.duration);
        }
      }
    }, 100);
  }

  async onDismiss(): Promise<void> {
    if (this.bannerElement?.nativeElement) {
      await this.bannerElement.nativeElement.setClose();
      this.currentBanner = null;
    }
  }
}
